import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wilson-rule-description',
  imports: [TranslatePipe],
  templateUrl: './rule-description.component.html',
  styleUrl: './rule-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RuleDescriptionComponent {
  @Input() customDescription!: string;
}
